export const FILTERS_MODAL_HEADING_TEXT = "All filters";

export const FILTERS_MODAL_CTA_TEXT = "All filters";

export const RESET_FILTERS_BUTTON_TEXT = "Reset filters";
export const APPLY_FILTERS_BUTTON_TEXT = "Apply filters";
export const APPLY_FILTERS_COUNT_BUTTON_TEXT = (count: number) =>
  `${APPLY_FILTERS_BUTTON_TEXT}${count > 0 ? ` (${count})` : ""}`;
export const MEAL_PLAN_FILTER_TITLE = "Meal Plan";
